module.exports = __webpack_public_path__ + "static/img/background3.eacb292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background3.png
// module id = vIEt
// module chunks = 0